import React from 'react';
import './Assessment.css';

const Assessment = (props: any) => {
	return (
		<div className="ui-container modal-disable-select">
			<p>This is an assessment</p>
			<div>
				<button>Yes</button>
				<button>No</button>
			</div>
		</div>
	);
};

export default Assessment;
